<div class="container py-4">
  <div class="row">
    <div class="card h-80 rounded-3 border-1 shadow-sm p-2">
      <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
         <!-- Compose Button (Admins Only) -->
          <p class="text-s fw-bold">Communications</p>
          <div v-if="isSystemAdmin" class="text-end mb-4">
            <button class="btn rounded-small fw-bold btn-darker text-xxs shadow me-2" @click="openCreateModal">
              <i class="bi bi-quill"></i> Compose
            </button>
          </div>
      </div>

      <div class="system-communications">
        <div class="main-content">
          <!-- Compose Modal (Admins Only) -->
          <div v-if="showCreateModal" class="modal-backdrop">
            <div class="modal-box">
              <div class="modal-header">
                <h3>Compose a Message</h3>
                <button class="btn-close" @click="closeCreateModal">&times;</button>
              </div>
              <div class="modal-body">
                <div id="quill-editor" class="rich-editor"></div>
              </div>
              <div class="modal-footer">
                <button 
                  class="btn rounded-small fw-bold bg-green text-xxs" 
                  @click="saveCommunication"
                  :disabled="isSaveDisabled"
                >
                  {{ editingCommId ? 'Update Communication' : 'Save Communication' }}
                </button>
              </div>
            </div>
          </div>

          <!-- Tabs Navigation -->
          <div class="tabs-container">
            <span v-if="!isSystemAdmin" class="tab-buttons">
              <button 
                class="tab-button"
                :class="{ active: activeTab === 'unread' }"
                @click="activeTab = 'unread'"
              >
                UNREAD
                <span v-if="unread_system_comms.length > 0" class="unread-badge ms-1">{{ unread_system_comms.length }}</span>
              </button>
              <button 
                class="tab-button"
                :class="{ active: activeTab === 'read' }"
                @click="activeTab = 'read'"
              >
                READ
              </button>
            </span>
            <span v-else class="tab-buttons">
              <button 
                class="tab-button"
                :class="{ active: activeTab === 'all' }"
                @click="activeTab = 'all'"
              >
                MESSAGES
              </button>
            </span>
          </div>

          <!-- Communications List -->
          <div class="communications-list">
            <!-- Unread Tab -->
            <div v-if="activeTab === 'unread'" class="tab-content">
              <div v-if="unread_system_comms.length === 0" class="empty-state">
                <div class="empty-message">
                  <h4>No unread communications</h4>
                  <p>All communications have been read</p>
                </div>
              </div>
              <div v-else>
                <div 
                  v-for="comm in unread_system_comms" 
                  :key="comm.id" 
                  class="communication-card unread"
                >
                  <div class="comm-header">
                    <div class="comm-meta">
                      <span class="comm-date">{{ formatDateTime(comm.date_created) }}</span>
                    </div>
                    <div class="comm-status">
                      <span class="status-badge">Unread</span>
                    </div>
                  </div>
                  <div class="comm-content">
                    <div v-html="comm.message" class="message-content"></div>
                  </div>
                  <div class="comm-actions">
                    <button class="btn rounded-small fw-bold btn-outline text-xxs" @click="markAsRead(comm.id)">
                      Mark as Read
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Read Tab -->
            <div v-else-if="activeTab === 'read'" class="tab-content">
              <div v-if="read_system_comms.length === 0" class="empty-state">
                <div class="empty-message">
                  <h4>No read communications</h4>
                  <p>No communications have been read yet</p>
                </div>
              </div>
              <div v-else>
                <div 
                  v-for="comm in read_system_comms" 
                  :key="comm.id" 
                  class="communication-card read"
                >
                  <div class="comm-header">
                    <div class="comm-meta">
                      <span class="comm-date">{{ formatDateTime(comm.date_created) }}</span>
                    </div>
                    <div class="comm-status">
                      <span class="status-badge">Read</span>
                    </div>
                  </div>
                  <div class="comm-content">
                    <div v-html="comm.message" class="message-content"></div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="tab-content">
              <div v-if="all_system_comms.length === 0" class="empty-state">
                <div class="empty-message">
                  <h4>No communications</h4>
                  <p>Click 'compose' to create a message</p>
                </div>
              </div>
              <div v-else>
                <div 
                  v-for="comm in all_system_comms" 
                  :key="comm.id" 
                  class="communication-card all"
                >
                  <div class="comm-header">
                    <div class="comm-meta">
                      <span class="comm-date">{{ formatDateTime(comm.date_created) }}</span>
                    </div>
                    <div class="comm-status">
                      <span class="status-badge">Sent</span>
                    </div>
                  </div>
                  <div class="comm-content">
                    <div v-html="comm.message" class="message-content"></div>
                  </div>
                  <div class="comm-actions">
                    <button
                      class="btn rounded-small fw-bold btn-outline text-xxs"
                      @click="editCommunication(comm)"
                    >
                      Edit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
